function dropdown() {
    const mediaQuery = window.matchMedia('(max-width: 767px)');

    const head = document.querySelector('.gh-navigation');
    const menu = head.querySelector('.gh-navigation-menu');
    const nav = menu?.querySelector('.nav');
    if (!nav) return;

    const updateStickyState = function () {
        if (mediaQuery.matches) {
            head.classList.remove('is-compact');
            return;
        }

        head.classList.toggle('is-compact', window.scrollY > 48);
    };

    let scrollFrame = null;

    window.addEventListener('scroll', function () {
        if (scrollFrame) {
            return;
        }

        scrollFrame = window.requestAnimationFrame(function () {
            updateStickyState();
            scrollFrame = null;
        });
    }, {passive: true});

    if (mediaQuery.addEventListener) {
        mediaQuery.addEventListener('change', updateStickyState);
    } else {
        mediaQuery.addListener(updateStickyState);
    }
    updateStickyState();

    const normalizeResourcesParentHref = function () {
        const resourcesItem = Array.from(nav.children).find(function (item) {
            const link = Array.from(item.children).find(function (child) {
                return child.tagName === 'A';
            });

            return link && link.textContent.trim().toLowerCase() === 'resources';
        });

        if (!resourcesItem) {
            return;
        }

        const resourcesLink = Array.from(resourcesItem.children).find(function (child) {
            return child.tagName === 'A';
        });

        if (!resourcesLink) {
            return;
        }

        let path = '';

        try {
            path = new URL(resourcesLink.getAttribute('href'), window.location.origin).pathname;
        } catch (e) {
            path = resourcesLink.getAttribute('href') || '';
        }

        if (path === '/' || path === '') {
            resourcesLink.href = '/resources/';
        }
    };

    const ensureSolutionsFallbackItems = function () {
        const solutionsItem = Array.from(nav.children).find(function (item) {
            const link = Array.from(item.children).find(function (child) {
                return child.tagName === 'A';
            });

            return link && link.textContent.trim().toLowerCase() === 'solutions';
        });

        if (!solutionsItem) {
            return;
        }

        const normalizedExisting = Array.from(nav.querySelectorAll('a')).map(function (link) {
            let path = '';

            try {
                path = new URL(link.getAttribute('href'), window.location.origin).pathname;
            } catch (e) {
                path = link.getAttribute('href') || '';
            }

            return {
                label: link.textContent.replace(/^-\s+/, '').trim().toLowerCase(),
                path: path.replace(/\/$/, '')
            };
        });

        const fallbackItems = [
            {label: '- Training', path: '/training/'},
            {label: '- Supervision', path: '/supervision/'}
        ];

        let insertAfter = solutionsItem;

        while (insertAfter.nextElementSibling) {
            const nextLink = Array.from(insertAfter.nextElementSibling.children).find(function (child) {
                return child.tagName === 'A';
            });

            if (!nextLink || !/^-\s+/.test(nextLink.textContent.trim())) {
                break;
            }

            insertAfter = insertAfter.nextElementSibling;
        }

        fallbackItems.forEach(function (fallback) {
            const normalizedLabel = fallback.label.replace(/^-\s+/, '').trim().toLowerCase();
            const normalizedPath = fallback.path.replace(/\/$/, '');
            const exists = normalizedExisting.some(function (existing) {
                return existing.label === normalizedLabel || existing.path === normalizedPath;
            });

            if (exists) {
                return;
            }

            const item = document.createElement('li');
            const link = document.createElement('a');

            link.href = fallback.path;
            link.textContent = fallback.label;
            item.appendChild(link);

            if (window.location.pathname.replace(/\/$/, '') === normalizedPath) {
                item.classList.add('nav-current');
            }

            insertAfter.insertAdjacentElement('afterend', item);
            insertAfter = item;
        });
    };

    const buildDashSubmenus = function () {
        const topLevelItems = Array.from(nav.children).filter(function (item) {
            return item.tagName === 'LI';
        });

        let currentParent = null;

        topLevelItems.forEach(function (item) {
            const link = Array.from(item.children).find(function (child) {
                return child.tagName === 'A';
            });

            if (!link) {
                return;
            }

            const label = link.textContent.trim();
            const isChild = /^-\s+/.test(label);

            if (!isChild) {
                currentParent = item;
                return;
            }

            if (!currentParent) {
                return;
            }

            link.textContent = label.replace(/^-\s+/, '').trim();
            item.classList.add('nav-child');
            currentParent.classList.add('has-submenu');

            const parentLink = Array.from(currentParent.children).find(function (child) {
                return child.tagName === 'A';
            });

            if (parentLink) {
                parentLink.setAttribute('aria-haspopup', 'true');
            }

            if (item.classList.contains('nav-current')) {
                currentParent.classList.add('has-current-child');
            }

            let submenu = Array.from(currentParent.children).find(function (child) {
                return child.classList?.contains('gh-navigation-submenu');
            });

            if (!submenu) {
                submenu = document.createElement('ul');
                submenu.className = 'gh-navigation-submenu';
                currentParent.appendChild(submenu);
            }

            submenu.appendChild(item);
        });
    };

    normalizeResourcesParentHref();
    ensureSolutionsFallbackItems();
    buildDashSubmenus();

    const logo = document.querySelector('.gh-navigation-logo');
    const navHTML = nav.innerHTML;

    if (mediaQuery.matches) {
        const items = nav.querySelectorAll('li');
        items.forEach(function (item, index) {
            item.style.transitionDelay = `${0.03 * (index + 1)}s`;
        });
    }

    const makeDropdown = function () {
        if (mediaQuery.matches) return;
        const submenuItems = [];

        while ((nav.offsetWidth + 64) > menu.offsetWidth) {
            if (nav.lastElementChild) {
                submenuItems.unshift(nav.lastElementChild);
                nav.lastElementChild.remove();
            } else {
                break;
            }
        }

        if (!submenuItems.length) {
            head.classList.add('is-dropdown-loaded');
            return;
        }

        const toggle = document.createElement('button');
        toggle.setAttribute('class', 'gh-more-toggle gh-icon-button');
        toggle.setAttribute('aria-label', 'More');
        toggle.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor"><path d="M21.333 16c0-1.473 1.194-2.667 2.667-2.667v0c1.473 0 2.667 1.194 2.667 2.667v0c0 1.473-1.194 2.667-2.667 2.667v0c-1.473 0-2.667-1.194-2.667-2.667v0zM13.333 16c0-1.473 1.194-2.667 2.667-2.667v0c1.473 0 2.667 1.194 2.667 2.667v0c0 1.473-1.194 2.667-2.667 2.667v0c-1.473 0-2.667-1.194-2.667-2.667v0zM5.333 16c0-1.473 1.194-2.667 2.667-2.667v0c1.473 0 2.667 1.194 2.667 2.667v0c0 1.473-1.194 2.667-2.667 2.667v0c-1.473 0-2.667-1.194-2.667-2.667v0z"></path></svg>';

        const wrapper = document.createElement('div');
        wrapper.setAttribute('class', 'gh-dropdown');

        if (submenuItems.length >= 10) {
            head.classList.add('is-dropdown-mega');
            wrapper.style.gridTemplateRows = `repeat(${Math.ceil(submenuItems.length / 2)}, 1fr)`;
        } else {
            head.classList.remove('is-dropdown-mega');
        }

        submenuItems.forEach(function (child) {
            wrapper.appendChild(child);
        });

        toggle.appendChild(wrapper);
        nav.appendChild(toggle);

        const toggleRect = toggle.getBoundingClientRect();
        const documentCenter = window.innerWidth / 2;

        if (toggleRect.left < documentCenter) {
            wrapper.classList.add('is-left');
        }

        head.classList.add('is-dropdown-loaded');

        window.addEventListener('click', function (e) {
            if (head.classList.contains('is-dropdown-open')) {
                head.classList.remove('is-dropdown-open');
            } else if (toggle.contains(e.target)) {
                head.classList.add('is-dropdown-open');
            }
        });
    }

    imagesLoaded(logo, function () {
        makeDropdown();
    });

    window.addEventListener('load', function () {
        if (!logo) {
            makeDropdown();
        }
    });

    window.addEventListener('resize', function () {
        setTimeout(() => {
            nav.innerHTML = navHTML;
            makeDropdown();
            updateStickyState();
        }, 1);
    });
}
